// extracted by mini-css-extract-plugin
module.exports = {"fondo_toggle":"ProcesoListado__fondo_toggle__30x2A","margen_toggle":"ProcesoListado__margen_toggle__1Ug2F"};